<template>
  <div class="partner-tab-sharing-level-cell">
    <PartnerTabSharingLevelPill v-if="variant" :variant="variant" />
    <span v-else class="text-sm text-neutral-text-placeholder">&ndash;</span>
  </div>
</template>

<script setup lang="ts">
import { ICellRendererParams } from '@ag-grid-community/core';
import { computed } from 'vue';

import {
  GREENFIELD_SHARING,
  HIDDEN,
  OLAPS_ONLY,
  SHARING,
  type SharingType,
} from '@/constants/data_shares';

import type {
  SharingLevelCellParamsType,
  SharingLevelVariantType,
  SharingPartnerRow,
} from '../types';

import PartnerTabSharingLevelPill from './PartnerTabSharingLevelPill.vue';

const { params } = defineProps<{
  params: ICellRendererParams<SharingPartnerRow> & SharingLevelCellParamsType;
}>();

const LEVEL_VARIANT: Record<SharingType, SharingLevelVariantType> = {
  [GREENFIELD_SHARING]: 'all',
  [SHARING]: 'overlaps',
  [OLAPS_ONLY]: 'counts',
  [HIDDEN]: 'hidden',
};

const variant = computed<SharingLevelVariantType | null>(() => {
  const level = params.data?.[params.side][params.segmentKey];
  return level ? LEVEL_VARIANT[level] : null;
});
</script>

<style lang="pcss">
@reference "../../../../css/theme.css";
.partner-tab-sharing-level-cell {
  @apply flex items-center justify-center h-full w-full py-6;
}
</style>
